import { render, staticRenderFns } from "./UpdateGroup.vue?vue&type=template&id=3f70bf54&scoped=true"
import script from "./UpdateGroup.vue?vue&type=script&lang=js"
export * from "./UpdateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70bf54",
  null
  
)

export default component.exports